import { valueToForm, arrayToForm } from '../../../web-app-components/utils/formInputs';

import parseCoordinates from '../../../utils/parseCoordinates';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const coordinatesToForm = (coordinates) => {
  const lngLatArr = parseCoordinates(coordinates);

  if (!lngLatArr) {
    return null;
  }

  const [lng, lat] = lngLatArr;
  return { lng, lat };
};

const formToCoordinates = (coordinates) =>
  `${coordinates.lat}, ${coordinates.lng}`;

export const toForm = ({
  Title,
  Description,
  Coordinates,
  categories,
  subcategories,
  Region,
  District,
  GoldCoinAmount,
  VideoURL,
  WebsiteURL,
  BookingURL,
  PhoneNumber_1,
  PhoneNumber_2,
  Pictures,
  AudioRecordings,
  locale: objectLocale,
}) => ({
  locale: objectLocale || 'lt-LT',
  Title: valueToForm(Title || ''),
  Description: valueToForm(Description || ''),
  Coordinates: coordinatesToForm(Coordinates),
  categories: (() => {
    const categoriesArray = arrayToForm(categories);
    // Return single category ID or null (for single select)
    return categoriesArray.length > 0 ? categoriesArray[0].id : null;
  })(),
  subcategories: arrayToForm(subcategories).map(({ id }) => id),
  Region: valueToForm(Region),
  District: valueToForm(District),
  GoldCoinAmount: valueToForm(GoldCoinAmount),
  VideoURL: valueToForm(VideoURL),
  WebsiteURL: valueToForm(WebsiteURL),
  BookingURL: valueToForm(BookingURL),
  PhoneNumber_1: valueToForm(PhoneNumber_1),
  PhoneNumber_2: valueToForm(PhoneNumber_2),
  Pictures: arrayToForm(Pictures).map(({ id, name, ext, formats, url: pictureUrlFallback }) => ({
    id,
    name: `${name}${ext}`,
    url: `${SERVER_URL}${formats?.thumbnail?.url || formats?.small?.url || pictureUrlFallback || ''}`,
  })),
  AudioRecordings: arrayToForm(AudioRecordings).map(
    ({ id, name, ext, url }) => ({
      id,
      name: `${name}${ext}`,
      url: `${SERVER_URL}${url}`,
    })
  ),
});

export const fromForm = ({
  locale,
  Title,
  Description,
  Coordinates,
  categories,
  subcategories,
  Region,
  District,
  GoldCoinAmount,
  VideoURL,
  WebsiteURL,
  BookingURL,
  PhoneNumber_1,
  PhoneNumber_2,
  Pictures,
  AudioRecordings,
}) => {
  const selectedLocale = locale || 'lt-LT';

  return {
    locale: selectedLocale,
    Title: Title || '',
    Description: Description || '',
    Coordinates: Coordinates ? formToCoordinates(Coordinates) : null,
    categories: categories ? [categories] : [],
    subcategories,
    Region,
    District,
    GoldCoinAmount,
    VideoURL,
    WebsiteURL,
    BookingURL,
    PhoneNumber_1,
    PhoneNumber_2,
    Pictures,
    AudioRecordings,
  };
};
